module.exports = __webpack_public_path__ + "img/banner-principal-mobile@3x.67639e8a.png";